module.exports = __webpack_public_path__ + "img/partner_img23.e1b54d69.png";